<template>
  <div class="container-fluid py-4 px-4">

    <div class="row no-gutters text-left">
      <div class="col-6">
        <div class="row">
          <div class="col-4">
            <h4 class="font-weight-bold mb-0">CMS Accounts</h4>
          </div>

          <div class="col-8">
            <div class="input-group input-group-sm mb-3">
              <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">
              &#128269;
            </span>
              </div>
              <input type="text"
                     class="form-control"
                     placeholder="Search"
                     aria-label="Search"
                     aria-describedby="basic-addon1">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row no-gutters text-left mt-3">
      <div class="col-6">
        <div class="row">
          <div class="col-6">
            <base-pagination :page-object="cmsUserPagination" @settingPage="setPage"></base-pagination>
          </div>

          <div class="col-6">
            <div class="form-group row">
              <label for="count-vessel" class="col-form-label">Count:</label>
              <div class="col-sm-4">
                <select class="form-control form-control-sm" name="countVessel" id="count-vessel"
                        v-model="formCmsUserData.count" @change="searchCmsUser">
                  <option :value="count" v-for="(count,index) in counts" :key="index">
                    <span>{{ count }}</span>
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row no-gutters text-left mt-lg-3">
      <base-table :loading="isLoading" :loader-colspan="6" :max-height="650">
        <template slot="table-header">
          <tr>
            <th style="width: 2% !important;">#</th>
            <th style="width: 20% !important;">LAST NAME</th>
            <th style="width: 20% !important;">FIRST NAME</th>
            <th style="width: 20% !important;">MIDDLE NAME</th>
            <th style="width: 20% !important;">USERNAME</th>
            <th style="width: 5% !important;">ACTION</th>
          </tr>
        </template>
        <template slot="table-body">
          <tr v-if="this.cmsUsers.length == 0">
            <td colspan="6">No record found</td>
          </tr>
          <tr v-else v-for="(cmsUser,index) in cmsUsers" :key="cmsUser.id">
            <td>{{index + cmsUserPagination.currentPage}}</td>
            <td class="text-left pl-lg-3 align-middle">{{cmsUser.lastName}}</td>
            <td class="text-left pl-lg-3 align-middle">{{cmsUser.firstName}}</td>
            <td class="text-left pl-lg-3 align-middle">{{cmsUser.middleName}}</td>
            <td class="text-left pl-lg-3 align-middle">{{cmsUser.userName}}</td>
            <td>
              <button class="btn btn-sm btn-info">
                <font-awesome-icon icon="bars"/>
                <span class="ml-1">Details</span>
              </button>
            </td>
          </tr>
        </template>
      </base-table>
    </div>




  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {AppMixins} from '../../../mixins/app.mixins';

export default {
  name: 'Index',

  /** mixins **/
  mixins: [AppMixins],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {};
  },

  /** methods**/
  methods: {
    ...mapActions(
        [
          'set_cms_user_paginated'
        ]
    ),

    searchCmsUser(){
      // console.log('Test searching 123 ')
    },

    setPage(e){
      // console.log('Test setting page 123',e)
    }

  },

  /**  computed  **/
  computed: {
    ...mapGetters(
        [
          'isLoading',
          'counts',
          'formCmsUserData',
          'cmsUsers',
          'cmsUserPagination',
        ]
    ),
  },

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
    if(this.cmsUsers.length == 0){
      this.set_cms_user_paginated(this.formCmsUserData);
    }
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
  },

};
</script>

<style scoped>

</style>
